export const changeOrganizationMembersRoleAndStatusBulkActionType = 'changeOrganizationMembersRoleAndStatus';
